import {
  FETCH_ORGANISATIONS,
  FETCH_ORGANISATIONS_ERROR,
  FETCH_ORGANISATIONS_SUCCESS,
  UPDATE_ORGANISATION,
  UPDATE_ORGANISATION_ERROR,
  UPDATE_ORGANISATION_SUCCESS,
  CREATE_ORGANISATION,
  CREATE_ORGANISATION_SUCCESS,
  CREATE_ORGANISATION_ERROR,
  SEARCH_ORGANISATION,
  SEARCH_ORGANISATION_ERROR,
  SEARCH_ORGANISATION_SUCCESS,
  FETCH_ORGANISATIONS_SERVICES,
  FETCH_ORGANISATIONS_SERVICES_ERROR,
  FETCH_ORGANISATIONS_SERVICES_SUCCESS,
} from "../../actions/receptionist/organisationsAction";

const INIT_STATE = {
  error: null,
  loading: false,
  orgServiceError: null,
  orgServiceLoading: false,
  data: [],
  total: 0,
};

export const organisationsReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_ORGANISATIONS:
      return { ...state, loading: true, error: null };
    case FETCH_ORGANISATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.insuranceOrganisations,
        total: action.payload.totalItems,
      };
    case FETCH_ORGANISATIONS_ERROR:
      return { ...state, loading: false, error: action.error };

    case SEARCH_ORGANISATION:
      return { ...state, loading: true, error: null };
    case SEARCH_ORGANISATION_SUCCESS:
      const existingOrgIds = new Set(state.data.map((org) => org.orgId));
      const uniqueOrganisations = action.payload.filter(
        (newOrg) => !existingOrgIds.has(newOrg.orgId)
      );

      return {
        ...state,
        loading: false,
        data: [...state.data, ...uniqueOrganisations],
      };
    case SEARCH_ORGANISATION_ERROR:
      return { ...state, loading: false, error: action.error };

    case CREATE_ORGANISATION:
      return { ...state, loading: true, error: null };
    case CREATE_ORGANISATION_SUCCESS:
      return {
        ...state,
        loading: false,
        data: [...state.data, action.payload],
      };
    case CREATE_ORGANISATION_ERROR:
      return { ...state, loading: false, error: action.error };

    case UPDATE_ORGANISATION:
      return { ...state, loading: true, error: null };
    case UPDATE_ORGANISATION_SUCCESS:
      const updatedOrganisations = state.data.map((organisation) => {
        if (organisation.orgId === action.payload.orgId) {
          return { ...action.payload };
        }

        return organisation;
      });

      return { ...state, loading: false, data: updatedOrganisations };
    case UPDATE_ORGANISATION_ERROR:
      return { ...state, loading: false, error: action.error };
    case FETCH_ORGANISATIONS_SERVICES:
      return { ...state, orgServiceLoading: true, orgServiceError: null };
    case FETCH_ORGANISATIONS_SERVICES_ERROR:
      return {
        ...state,
        orgServiceLoading: false,
        orgServiceError: action.error,
      };
    case FETCH_ORGANISATIONS_SERVICES_SUCCESS:
      const organisationWithServices =
        state.data.length &&
        state.data.map((org) => {
          const orgService = action.payload.find(
            (service) => org.shortName === service.id
          );

          return {
            ...org,
            services: (orgService && orgService.service) || [],
          };
        });

      return {
        ...state,
        orgServiceError: false,
        orgServiceLoading: false,
        data: organisationWithServices,
      };
    default:
      return state;
  }
};
